import { DashboardItem } from '@app/modules/admin/screens/dashboard/DashboardItem';
import { FormattedMessage } from 'react-intl';
import { useEnabledSocialPlatforms } from '../../hooks/useEnabledSocialPlatforms';

export function SocialExportDashboardItems() {
  const platforms = useEnabledSocialPlatforms();

  return (
    <>
      {platforms.map((platform) => {
        return (
          <DashboardItem
            key={platform.id}
            icon={platform.Icon()}
            title={
              <FormattedMessage
                id={`admin.socialExport.title`}
                defaultMessage="Integración con {name}"
                values={{
                  name: platform.name,
                }}
              />
            }
            content={
              <FormattedMessage
                id={`admin.socialExport.body`}
                defaultMessage="Configurar upload a {platformName} para fragmentos"
                values={{
                  platformName: platform.name,
                }}
              />
            }
            actions={[
              {
                to: `/admin/social-export/${platform.id.toLowerCase()}`,
                text: (
                  <FormattedMessage
                    id="admin.dashboard.youtubeBtnText"
                    defaultMessage="Configurar"
                  />
                ),
              },
            ]}
          />
        );
      })}
    </>
  );
}
